import { plural } from '@cian/utils';
import { NBSP } from '../../constants/symbols';
import { formatMoney } from '../string';

interface IParams {
  price: number;
  days?: number | null;
}

export const formatPrice = ({ price, days }: IParams) => {
  const formattedSum = formatMoney(price);
  const period = days && plural(days, ['день', `${days} дня`, `${days} дней`]);

  return [formattedSum, period].filter(Boolean).join(' / ').replace(' ', NBSP);
};
